<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goToBack()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                    Add Network Outage 
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="row mt-3">
                <div class="col-xl-2"></div>
                <div class="col-xl-8">
                    <div class="row">

                    </div>
                    <div class="row">
                        <div class="col-xl-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Service Provider</mat-label>
                                <mat-select class="scrollbarcs" formControlName="serviceProviderId"
                                    placeholder="Please Select Service Provider" [disabled]="isDisableServiceProvider">
                                    <mat-select-filter [displayMember]="'value'" [array]="serviceProviderList"
                                        (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Province</mat-label>
                                <mat-select class="scrollbarcs" formControlName="provinces"
                                    placeholder="Please Select Province">
                                    <mat-select-filter [displayMember]="'value'" [array]="provinceList"
                                        (filteredReturn)="filteredList3 = $event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredList3" [value]="item.value"
                                        style="overflow-y: scroll !important;">
                                        {{item.value}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-xl-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>City / Suburb</mat-label>
                                <input matInput maxlength="50" formControlName="city" placeholder="Enter City / Suburb"
                                    class="col-12" autocomplete="off" >
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Outage Status</mat-label>
                                <input matInput  class="col-12" autocomplete="off" readonly
                                [value]="form.get('outageStatus').value === 1 ? 'Open' : 'Close'">
                            </mat-form-field>
                        </div>
                        <div class="col-xl-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Subject</mat-label>
                                <input matInput maxlength="50" formControlName="subject" placeholder="Enter Subject"
                                    class="col-12" autocomplete="off" >
                            </mat-form-field>
                        </div>
                        <div class="col-xl-12">
                        <div class="editor  mt-3" style="background: white;">
                            <quill-editor formControlName="description" [modules]="toolbarModules"></quill-editor>
                        </div>
                    </div>
                    <div class="col-12 mt-4 d-flex justify-content-center">
                        <button class="btn reset_btn mr-3 " (click)="reset()">
                            <i class="fa fa-refresh"></i> Reset
                        </button>
                        <button class="btn btn-primary mr-3" (click)="save()">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-xl-2"></div>
    </div>
    </form>
</div>
</div>